import React from 'react';
import './pagination.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const POSPagination = ({ pagination, getItems, pageSize, setPageSize }) => {
  const currentPage = pagination?.currentPage ?? 1;
  const totalPages = pagination?.totalPages; // can be null
  const hasPrev = pagination?.hasPrevious ?? currentPage > 1;
  const hasNext = pagination?.hasNext ?? false;

  const canShowNumbers = Number.isFinite(+totalPages) && +totalPages > 0;

  const renderPageNumbers = () => {
    if (!canShowNumbers) return null;

    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 4);

    let startPage = Math.max(currentPage - Math.floor(totalPageNumbers / 2), 1);
    let endPage = startPage + totalPageNumbers - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - totalPageNumbers + 1);
    }

    if (startPage > 1) {
      pageNumbers.push(
        <div key={1} className={`page ${currentPage === 1 ? 'active' : ''}`} onClick={() => getItems(1)}>
          1
        </div>
      );
      if (startPage > 2)
        pageNumbers.push(
          <div key="ellipsis1" className="ellipsis">
            ...
          </div>
        );
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} className={`page ${currentPage === i ? 'active' : ''}`} onClick={() => getItems(i)}>
          {i}
        </div>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1)
        pageNumbers.push(
          <div key="ellipsis2" className="ellipsis">
            ...
          </div>
        );
      pageNumbers.push(
        <div key={totalPages} className={`page ${currentPage === totalPages ? 'active' : ''}`} onClick={() => getItems(totalPages)}>
          {totalPages}
        </div>
      );
    }

    return pageNumbers;
  };

  const onChangePageSize = (e) => {
    const newSize = Number(e.target.value) || 20;
    setPageSize(newSize);
    // EmployeeList useEffect will refetch page 1
  };

  return (
    <div className="paginationbrdr border-0 p-0">
      <div className="pagination-container row align-items-center">
        <div className="col-8">
          <div className="pagination-controls gap-3 w-100 d-flex align-items-center">
            <button className={`prev ${!hasPrev ? 'disabled' : ''}`} onClick={() => getItems(currentPage - 1)} disabled={!hasPrev}>
              <FaChevronLeft />
            </button>

            <div className="page-numbers gap-3 d-flex align-items-center">
              {canShowNumbers ? renderPageNumbers() : <div className="page active">{currentPage}</div>}
            </div>

            <button className={`next ${!hasNext ? 'disabled' : ''}`} onClick={() => getItems(currentPage + 1)} disabled={!hasNext}>
              <FaChevronRight />
            </button>

            {/* ✅ Page size dropdown */}
            <div className="ms-3 d-flex align-items-center gap-2">
              <span style={{ fontSize: 12 }}>Rows:</span>
              <select value={pageSize} onChange={onChangePageSize} className="form-select form-select-sm" style={{ width: 90 }}>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-4 end">Total : {pagination?.totalRecords ?? '-'}</div>
      </div>
    </div>
  );
};

export default POSPagination;
